export const setores = [
    { id: 1, nome: 'Pedagógico', showSelectCursos: true },
    { id: 2, nome: 'Secretaria', showSelectCursos: false },
    { id: 3, nome: 'Financeiro', showSelectCursos: false },
    { id: 4, nome: 'Portaria', showSelectCursos: false },
    { id: 5, nome: 'Limpeza', showSelectCursos: false },
    { id: 6, nome: 'Manutenção', showSelectCursos: false },
    { id: 7, nome: 'Comercial', showSelectCursos: false },
    { id: 8, nome: 'Outros', showSelectCursos: false }
  ]